import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class SheduleTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Alarm Zeitplan" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Alles auswählen', descriptionColumn: 'Klicken Sie hier, um die Alarmaktionen 24/7 zu aktivieren. Jede aktive Alarmfunktion (Bewegungserkennung, Audioalarm und externer Alarmeingang) kann die eingestellten Alarmaktionen auslösen.' },
        { actionColumn: 'Alles abwählen', descriptionColumn: 'Klicken Sie hier, um die Alarmaktionen 24/7 zu deaktivieren. Jede aktive Alarmfunktion (Bewegungserkennung, Audioalarm und externer Alarmeingang) kann die eingestellten Alarmaktionen auslösen.' },
        { actionColumn: 'Arbeitszeit', descriptionColumn: 'Klicken Sie hier, um die Alarmaktionen während der Normalarbeitszeit zu aktivieren. Alle aktiven Alarmfunktionen werden so eingestellt, dass sie während dieses Zeitfensters Alarmaktionen auslösen.' },
        { actionColumn: 'Nachtzeit', descriptionColumn: 'Klicken Sie hier, um die Alarmaktionen in der Nacht zu aktivieren. Alle aktiven Alarmfunktionen werden so eingestellt, dass sie während dieses Zeitfensters Alarmaktionen auslösen.' },
        { actionColumn: 'Alles Invertieren', descriptionColumn: 'Diese Schaltfläche invertiert das ausgewählte Zeitfenster.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

SheduleTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(SheduleTable)